<div class="container">
  <div class="entry-details-minimal mt-4 mb-4" *ngIf="personInfo">
    <div class="entry-details-header">TRAINER DETAILS</div>
    <div class="entry-details-row">
      <span class="entry-details-label">Name:</span>
      <span class="entry-details-value">{{ personInfo.lastname }}, {{ personInfo.name }}</span>
    </div>
    <div class="entry-details-row">
      <span class="entry-details-label">City, State:</span>
      <span class="entry-details-value">{{ personInfo.ciudad || '-' }}, {{ personInfo.estado || '-' }}</span>
    </div>
    <div class="entry-details-row">
      <span class="entry-details-label">Country:</span>
      <span class="entry-details-value">{{ personInfo.pais?.nombre || '-' }}</span>
    </div>
    <div class="entry-details-row">
      <span class="entry-details-label">USEF:</span>
      <span class="entry-details-value">{{ personInfo.usef_id || '-' }}</span>
    </div>
    <div class="entry-details-row">
      <span class="entry-details-label">USHJA ID:</span>
      <span class="entry-details-value">{{ personInfo.ushja_id || '-' }}</span>
    </div>
  </div>
  <div class="card mt-4">
    <div class="card-body" style="padding: 0 1rem;" *ngIf="personInfo">
      <h1>
        Class Entries
      </h1>
      <hr class="m-0">

      <div>
        <table class="table table-sm table-entries">
          <thead>
            <tr>
              <th (click)="sort('entry')" class="sortable-header">
                ENTRY {{ getSortIcon('entry') }}
              </th>
              <th (click)="sort('rider')" class="sortable-header">
                RIDER {{ getSortIcon('rider') }}
              </th>
              <th (click)="sort('class')" class="sortable-header">
                CLASS {{ getSortIcon('class') }}
              </th>
              <th (click)="sort('rank')" class="sortable-header">
                RANK {{ getSortIcon('rank') }}
              </th>
              <!-- <th>RING</th> -->
              <th (click)="sort('day')" class="sortable-header">
                DAY {{ getSortIcon('day') }}
              </th>
             
            </tr>
          </thead>
                      <tbody>
              <tr *ngFor="let row of getSortedEntries()">
              <td>
                <a [href]="'/entry/' + showId + '/' + row.entryNumber">
                  {{ row.entryNumber }} - {{ row.horseName }}
                </a>
              </td>
              <td>{{ row.riderName }}</td>
              <td>
                <a [href]="'/competition/' + showId + '/' +  row.ipc ">
                  {{ row.numeroPrueba }} - {{ row.className }}
                </a>
              </td>
              <td>{{ row.rank }}</td>
              <!-- <td>{{ row.pista }}</td> -->
              <td>{{ row.classDate | date:'MM/dd/yy' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="m-4  text-center">
        NOTE: This lists all the entries linked to this trainer for the current show.
      </div>
    </div>
  </div>
</div>
